import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Popover from "@mui/material/Popover";
import PrimaryTextField from "../../../Inputs/PrimaryTextField/PrimaryTextField";
import FilterButton from "../../../Buttons/FilterButton/FilterButton";

export default function NumberRangeFilter({
  column: { filterValue, setFilter, Header },
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEnter = () => {
    setFilter([
      minValue ? parseInt(minValue, 10) : undefined,
      maxValue ? parseInt(maxValue, 10) : undefined
    ]);

    handleClose();
  };

  useEffect(() => {
    if (filterValue) {
      if (!filterValue[0]) {
        setMinValue("");
      }

      if (!filterValue[1]) {
        setMaxValue("");
      }
    } else {
      setMinValue("");
      setMaxValue("");
    }

  }, [filterValue]);

  const open = Boolean(anchorEl);
  const pid = open ? "simple-popover" : undefined;

  return (
    <>
      <FilterButton 
        filterValue={filterValue}
        onClick={handleClick}
      />
      <Popover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        <div style={{ padding: "20px 20px 10px 20px" }}>
          <PrimaryTextField
            id={`number-range-filter-min-${Header}`}
            value={minValue}
            onChange={setMinValue}
            label={`Min ${Header}`}
            onEnter={handleEnter}
          />
        </div>
        <div style={{ padding: "10px 20px 20px 20px" }}>
          <PrimaryTextField
            id={`number-range-filter-max-${Header}`}
            value={maxValue}
            onChange={setMaxValue}
            label={`Max ${Header}`}
            onEnter={handleEnter}
          />
        </div>
      </Popover>
    </>
  );
}

NumberRangeFilter.propTypes = {
  column: PropTypes.object.isRequired
};